import React from 'react';
import { Consumption } from 'src/types/ViewModel/Aol/Consumption';
import OdfjellInputComponent, { InputChangeData } from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { ConsumptionWrapper } from './Consumption.style';
import { AolDataItem } from 'src/types/ViewModel/AolItem';

interface Props {
    aolItem: AolDataItem;
    isReadOnly: boolean;
    consumption: Consumption;
    allConsumption: Consumption[];
    description: string;
    onChange: (inputData: InputChangeData) => void;
    cost?: number;
    availableRobForTank?: number;
    availableRobForBunkerRef?: number;
    previousRobExists?: boolean;
}

const ConsumptionData: React.FC<Props> = (props) => {
    const getWarningText = () => {
        if (!props.previousRobExists) return '';
        if (props.consumption.consumptionMt > props.availableRobForTank) {
            return 'Consumption exceeds available ROB';
        } else {
            return '';
        }
    };

    return (
        <ConsumptionWrapper>
            <OdfjellInputComponent
                isReadOnly={props.isReadOnly}
                type={'number'}
                value={props.consumption.consumptionMt}
                dataObject={props.consumption}
                extraArgs={props.aolItem}
                description={props.description}
                onChange={props.onChange}
                name={'consumptionMt'}
                min={0}
                max={100}
                unit={'MT'}
                cost={props.cost}
                warningText={getWarningText()}
            />
        </ConsumptionWrapper>
    );
};

export default ConsumptionData;
